<a class="skip-to-content" href="#main-content">Skip to content</a>
<tour-step-template>
    <ng-template let-step="step">
        <div class="flex flex-col rounded-md p-2" (click)="$event.stopPropagation()">
            <div class="flex space-x-4 justify-between items-center px-4 mb-2">
                <span class="text-lg leading-6 font-semibold">{{ step?.title }}</span>
                <mat-icon svgIcon="heroicons_outline:x-mark" (click)="tourService.end()"></mat-icon>
            </div>

            <span class="max-w-200 px-4" [innerHTML]="step?.content"></span>

            <div class="flex space-x-4 justify-between items-center">
                <button mat-icon-button [disabled]="!tourService.hasPrev(step)" (click)="tourService.prev()">
                    <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
                </button>
                @if (tourService.hasNext(step)) {
                    <button mat-icon-button (click)="tourService.next()">
                        <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                }
                @if (!tourService.hasNext(step)) {
                    <button mat-icon-button (click)="tourService.end()">
                        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                    </button>
                }
            </div>
        </div>
    </ng-template>
</tour-step-template>

@if (userImpersonatingMode()) {
    <div class="fixed left-0 right-0 mx-auto top-0 w-80 bg-orange-500 text-center font-bold text-white border-b rounded-b-lg z-999">User Impersonating Mode</div>
}

<router-outlet id="main-content"></router-outlet>
<app-floating-hub></app-floating-hub>
